export enum EInvitedOnboardingStep {
    ACTIVATE = 'ACTIVATE',
    CREATE_PROFILE = 'CREATE_PROFILE',
    SETUP_SERVICES = 'SETUP_SERVICES',
    AVAILABILITY = 'AVAILABILITY',
    MARKETING_PROFILE = 'MARKETING_PROFILE',
}

export interface InvitedOnboardingStepConfig {
    key: EInvitedOnboardingStep;
    title: string;
    order: number;
}
